import React, { Component } from "react";
import { connect } from "react-redux";

import style from "./GymRegistration.module.css";
import logo from "../../assets/Images/logo.png";

import "./GymRegistration.css";

import { withRouter } from "react-router-dom";

import GymInformationForm from "./GymInformationForm";

export default connect(
  null,
  null
)(
  withRouter(
    class GymRegistrationGymCreationForm extends Component {
      render() {
        return (
          <div className={style.container}>
            <div className={style.formContainer2}>
              <div className="logo">
                <img src={logo} className="w-100" alt="not found" />
              </div>
              <p className="mt-4 pl-3">
                <b>To complete your registration, add your gym details</b>
              </p>
              <hr className="mt-0" />
              <GymInformationForm />
            </div>
            <div class="cornerBtnStyle">
              <a class="text-white" href="/login">
                <button class="basicBtnStyle secondaryBtn">Login</button>
              </a>
            </div>
          </div>
        );
      }
    }
  )
);
